
// поиск  / фильтры сертификатов

import Notify from "./../notify"

export default  class CertificateFilter {
  constructor() {
    this.data = {
      q: null,
      dataorder: null,
      pay: null,
      name: null
    }

  }
  search() {
    $.ajax({
      method: "POST",
      url: "/themes/ahtilahti/ajax/certificates-list.php",
      async: false,
      data: {
        action: "search_certificates",
        q: this.data.q,
        dataOrder:this.data.dataorder,
        pay: this.data.pay,
        name: this.data.name
      },
      success: function (response) {


          $("#certificates-table").html(response);
      },
      error(xhr, status, error) {
        new Notify(error, "alert");

      }
    });


  }

  init() {
    let instance = this;

    $(document).on("click", "#date-asc", function(e) {
       e.preventDefault();
       instance.data.name =  null;
       instance.data.dataorder =  "ASC";
       instance.search();


    });


  $(document).on("click", "#date-desc", function(e) {
    e.preventDefault();
    instance.data.name =  null;
    instance.data.dataorder =  "DESC";
    instance.search();

  });

  $(document).on("click", "#name-asc", function(e) {
    instance.data.dataorder = null;
    e.preventDefault();
    instance.data.name =  "ASC";
    instance.search();


 });


$(document).on("click", "#name-desc", function(e) {

 e.preventDefault();
 instance.data.dataorder =  null;
 instance.data.name =  "DESC";
 instance.search();

});




  $("#cert-search").on("keyup",function() {
    let value = $(this).val().trim();
    instance.data.q = value;
    instance.search();
});


$(document).on("click", "#pay-ok", function(e) {
  e.preventDefault();
  $("#pay-no").find("svg").removeAttr("style");


  if(  instance.data.pay =="ok") {
    instance.data.pay  = null;
    $(this).find("svg").removeAttr("style");
  }
    else {
      $(this).find("svg").attr("style", "border: 1px solid red; border-radius: 50%;")

      instance.data.pay =  "ok";
    }


  instance.search();

});

$(document).on("click", "#pay-no", function(e) {
  e.preventDefault();
  $("#pay-ok").find("svg").removeAttr("style");

  if(  instance.data.pay =="no") {

    instance.data.pay  = null;

    $(this).find("svg").removeAttr("style");

  }else {

    $(this).find("svg").attr("style", "border: 1px solid red; border-radius: 50%;")


    instance.data.pay =  "no";
  }



  instance.search();

});





  }
}